import { ApiClient } from '../../api-client/api-client';

export const getAllSubmittalCodesByProjectId = (projectId: string) => {
  return ApiClient.getAllSubmittalCodesByProjectId({ projectId }).then((res) => res.data);
};
